import { req } from '../@api/request';

export default class InterestSerivce {
  static groupList = async () => {
    const result = await req.get(`/interest/group`);
    return result.data;
  };
  static register = async (data: any) => {
    const result = await req.post('/interest/group', data);
    return result.data;
  };
  static delete = async (group_idx: number) => {
    const result = await req.delete(`/interest/group?group_idx=${group_idx}`);
    return result.data;
  };
  static updateGroup = async (data: any) => {
    const result = await req.patch('/interest/group', data);
    return result.data;
  };
  static add = async (data: any) => {
    const result = await req.post('/interest', data);
    return result.data;
  };
  static list = async (
    is_interest: string,
    type: string,
    isCourtOrRegion: string,
    court: string,
    region: string,
    search: string,
    search2: string,
    bidStatus: string,
    totalCategory: string,
    group_idx: number,
    level: number,
    sort: string,
    limit: number,
    offset: number,
  ) => {
    const result = await req.get(
      `/interest?is_interest=${is_interest}&type=${type}&isCourtOrRegion=${isCourtOrRegion}&court=${court}&region=${region}&search=${search}&search2=${search2}&bidStatus=${bidStatus}&totalCategory=${totalCategory}&group_idx=${group_idx}&level=${level}&sort=${sort}&limit=${limit}&offset=${offset}`,
    );
    return result.data;
  };
  static dislike = async (iidx: number) => {
    const result = await req.delete(`/interest?iidx=${iidx}`);
    return result.data;
  };
  static updateInterestItem = async (data: any) => {
    const result = await req.patch('/interest', data);
    return result.data;
  };
  static check = async (iidx: number) => {
    const result = await req.get(`/interest/${iidx}`);
    return result.data;
  };
}
